import React from 'react';
import Header from './Header/Header';
import HeaderLinks from './Header/HeaderLinks';

import styles from './Header/headerLinksStyle';
import { Link, withRouter } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(styles);

function Layout(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.fixAll}>
        <Header
          brand={
            <Link to='/index' className={classes.navLink}>
              {' '}
              <div>Loan System</div>{' '}
            </Link>
          }
          rightLinks={<HeaderLinks />}
          fixed
          color='transparent'
          changeColorOnScroll={{
            height: 50,
            color: 'white'
          }}
          {...props}
        />
        <div style={{ padding: '0 0.5rem' }}>
          <div
            style={{
              height: '14vh',
              width: '100%',
              background: 'transparent'
            }}
          ></div>
          {props.children}
        </div>
      </div>
    </React.Fragment>
  );
}
export default withRouter(Layout);
